module.exports = __webpack_public_path__ + "img/11_2.eb829449.png";